import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import classes from "./Waiting.module.scss"
import logo from "../../../static/images/Logo.png";
import PillButton from "../../../components/PillButton";
import { APIContext } from "../../../connector";

const Waiting = () => {
  const navigate = useNavigate()
  const { logout, switchProfile } = useContext(APIContext);

  return (
    <>
      <div className={classes.container}>
        <img src={logo} alt="Waiting" className={classes.image} />
        <p className={classes.waitMessage}>Waiting for Approval...</p>
        <Link className={classes.switchLink} onClick={() => {
          switchProfile("CLIENT")
            .then(() => {
              navigate("/");
            })
        }}>
          Proceed as passenger instead? Click here
        </Link>
        <p className={classes.waitDescription}>Your account is currently under review. Please wait be patient.</p>
        {/* logout button using PillButton */}
        <PillButton
          className={classes.logoutButton}
          onClick={logout}
        >
          Logout
        </PillButton>
      </div>
    </>
  );
};

export default Waiting;
